import { db } from "../config";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  updateDoc,
  doc,
  addDoc,
} from "firebase/firestore";

export const NOTIFICATION_TYPES = {
  LIKE_REVIEW: "LIKE_REVIEW",
  NEW_FOLLOWER: "NEW_FOLLOWER",
  BOOK_CLUB_UPDATE: "BOOK_CLUB_UPDATE",
  READING_GOAL_ACHIEVED: "READING_GOAL_ACHIEVED",
  COMMENT_ON_REVIEW: "COMMENT_ON_REVIEW",
  LIST_FOLLOWER: "LIST_FOLLOWER",
};

export const createNotification = async (notification) => {
  try {
    const notificationsRef = collection(db, "Notifications");
    const newNotification = {
      ...notification,
      createdAt: new Date().toISOString(),
      read: false,
    };
    await addDoc(notificationsRef, newNotification);
  } catch (error) {
    console.error("Error creating notification:", error);
    throw error;
  }
};

export const getNotifications = async (userId, _page = 1, pageSize = 20) => {
  try {
    const q = query(
      collection(db, "Notifications"),
      where("userId", "==", userId),
      orderBy("createdAt", "desc"),
      limit(pageSize)
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const markAsRead = async (notificationId) => {
  try {
    const notificationRef = doc(db, "Notifications", notificationId);
    await updateDoc(notificationRef, { read: true });
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};

export const getUnreadCount = async (userId) => {
  try {
    const q = query(
      collection(db, "Notifications"),
      where("userId", "==", userId),
      where("read", "==", false)
    );
    const snapshot = await getDocs(q);
    return snapshot.size;
  } catch (error) {
    console.error("Error getting unread count:", error);
    throw error;
  }
};
